// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".emoji[data-v-3b50148e]{display:flex;flex-direction:column;justify-content:center}.emoji .pane[data-v-3b50148e]{display:flex;flex-wrap:wrap;height:260px;width:350px}.emoji .pane span[data-v-3b50148e]{font-size:20px;padding:3px}.emoji .el-pagination[data-v-3b50148e]{margin-top:10px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
